export default {
  register: {
    Placeholder: {
      loginName: "Please enter a username",
      registTel: "Please enter your phone number or email",
      mobileCode: "Please enter the verification code",
      password: "Set a 6-20 digit login password",
      confirmPassword: "Please re-enter your login password",
    },
    Button: {
      Agreement: "<Buyer User Agreement>",
      loginSubBtn: "Register",
      getCode: {
        countdown: "Get Verification Code",
        countdownChange: "s Resend Verification Code"
      }
    },
    Checkbox: {
      registerAgree: "Check to indicate your agreement",
    },
    loginOtherOpts: {
      haveAccuont: "Already have an account, ",
      href: "Log In Now"
    },
    dialog: {
      title: "Image Verification Code",
      button: "Confirm",
      placeholder: "Please enter the image verification code",
    },
    rules: {
      required: {
        loginName: "Please enter a username",
        registTel: "Please enter a phone number or email",
        mobileCode: "Please enter the verification code",
        password: "Please enter a password",
        confirmPassword: "Please re-enter your password"
      },
      validator: {
        loginNameRepeat: "Username already exists",
        registTelFormat: "Please enter a valid phone number or email",
        registTelRepeat: "Phone number already exists",
        confirmPassword: "Passwords do not match"
      },
      pattern: {
        loginNameFormat: "Please enter a 4-16 character username containing letters, numbers, and underscores",
        passwordFormat: "Please enter a 6-16 character password containing letters, numbers, and underscores"
      }
    },
    Message: {
      Agreement: "Please accept the Buyer User Agreement"
    },
  }
}